<template>
<div class="">
  <com-header :compID="$route.params.compid" activeKey="lbj" @returnCompInfo="returnCompInfo"></com-header>
  <div class="product-collect layout-router">
    <catalog-tree
      title="产品目录"
      categoryType="ProdDir"
      @dirChanged="dirChanged"
      :defaultNode="defaultNode"
      :compID="$route.params.compid"
      viewHeight="calc(100vh - 57px)"
      affixTop="40px"
      :lazy="false"
      :defaultExpandedKeys="[`list_${defaultSID}`]"
      :currentKey="`list_${defaultSID}`"
      ref="catalogTreeRef"
    ></catalog-tree>
    <prod-list
      :defaultNode="[{DirName: '产品目录', DirID: 0, TreeID: 'list_0'}]"
      ref="prodListRef"
      :compVipLevel="compInfo.VipLevel"
    />
  </div>
</div>
</template>

<script>
import ComHeader from '/@/views/company/header/index.vue';
import CatalogTree from '@/components/tree-list/catalog-tree.vue';
import ProdList from './prod-list.vue';
import { WinForm } from '@/libs';

export default {
  data(){
    return {
      defaultNode: [
        { DirName: '产品目录' ,DirID: 0,TreeID: 'list_0'}
      ],
      defaultSID: 0,
      compInfo: {},
    }
  },
  components: { ComHeader, CatalogTree, ProdList },
  created() {
    this.defaultSID = WinForm.storge.localGet('dir_id', true) || '0';
  },
  methods: {
    dirChanged(data, parents) {
      this.$refs.prodListRef.dirChanged(data.DirID || 0, parents);
    },
    returnCompInfo(compInfo = {}) {
      this.compInfo = compInfo;
    }
  }
}
</script>

<style lang="less" scoped>
.product-collect{
  display: flex;
  flex-direction: row;
}
.left-dir{
  width: 338px;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  padding-top: 56px;
  position: relative;
  /deep/ .el-tree{
    padding: 12px;
  }
  /deep/ .el-tree-node__content{
    margin-bottom: 6px;
  }
  .title{
    height: 56px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    padding-left: 22px;
    z-index: 1;
    span{
      font-weight: 400;
      color: #0989C5;
      line-height: 56px;
      background: linear-gradient(90deg, #0A89C5 0%, #995CB6 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>
